import { ReflectUtils } from "@dooboostore/core";
const InjectionMetadataKey = Symbol("Injection");
function Injection(configOrTarget, propertyKey, descriptor) {
  if (propertyKey && descriptor) {
    const target = configOrTarget;
    ReflectUtils.defineMetadata(InjectionMetadataKey, {}, target, propertyKey);
  } else {
    return (target, propertyKey2, descriptor2) => {
      const config = configOrTarget;
      ReflectUtils.defineMetadata(InjectionMetadataKey, config ?? {}, target, propertyKey2);
    };
  }
}
const getInjection = (target, propertyKey) => {
  return ReflectUtils.getMetadata(InjectionMetadataKey, target, propertyKey);
};
const injection = Injection;
export {
  Injection,
  getInjection,
  injection
};
//# sourceMappingURL=Injection.js.map
